import React from "react";
import "./dimaagi-naxal-page.m.css";
import { useSelector } from "react-redux";
import get from "lodash/get";


export function DimaagiNaxalPage() {

  const member = useSelector(state => {
    return get(state, ["member"], null);
  });
    


  const isActive = useSelector(state =>
    get(state, ["fetchSubscription", "isActive"], null)
  );

  const handleBuyNow = (planId) => () => {
    window.open(`https://razorpay.com/payment-button/${planId}/view`, "_blank");
  };

  return (
    <div styleName="wrapper">
      <h1 styleName="title">Dimaagi Naxal Series</h1>
      <br />
      <div styleName="top-wrapper">
        <div styleName="img-wrap">
          <img
            alt="banner"
            src="https://images.assettype.com/newslaundry/2026-09-17/lvfludgb/All-dimagi-naxal-merch.jpg"
          />
        </div>
        <div styleName="text-wrap">
          <p styleName="description">
            {" "}
            They called it "Dimagi Naxal." <br />
            <br />
            We called it merch.
            <br />
            <br />
            The Dimagi Naxal Series Hamper is our way of celebrating the people
            who've always kept journalism alive: readers who question, doubt,
            argue, and pay to keep news free.
            <br /> <br />
            Because labels come and go. Questions stay.
            <br />
            <br />
            Wear it. Sip from it. Gift it. And wear the accusation like a
            compliment.
          </p>
        </div>
      </div>
      <br />
      <div styleName="hamper__container">
      
     { !!member?.name && isActive ?  <>
       <img
            alt=""
            src="https://images.assettype.com/newslaundry/2026-09-17/vlhlupyz/urban-naxal-campaign-merch-hamper-Subs.jpg"
          />
      <div styleName="hamper__card">
          <h2 styleName="hamper__title">Subscribers</h2>
        

          <ul style={{ height: "70%" }}>
            <li>Dimmagi Naxal Shirt Black</li>
            <li>Dimmagi Naxal Shirt White</li>
            <li>Urban Naxal Mug</li>
            <li>Dimaagi Naxal Mug</li>
            <li>Naxal Bari Book</li>
            {/* <li>NL-TNM mug worth ₹399/-</li>
            <li>Urban Naxal Mug worth ₹349/-</li>
            <li>2 x One Month Joint NL-TNM Subscription worth ₹1000/-</li> */}
          </ul>
          <h2 styleName="hamper__price-1">
            <span styleName="rupee_sign1">Total </span>
            <span styleName="rupee_sign1">₹</span>
            <span
              styleName="rupee_sign1"
              style={{ textDecoration: "line-through" }}
            >
              2996
            </span>
          </h2>
          <h2 styleName="hamper__price-2">
            <span styleName="rupee_sign">₹</span>2580
          </h2>

          <button onClick={handleBuyNow("pl_TccGxLaxfmAWux")}>Buy Now</button>
        </div></>:
         <>
           <img
            alt=""
            src="https://images.assettype.com/newslaundry/2026-09-17/suq8iev2/urban-naxal-campaign-merch-hamper-Non-Subs.jpg"
          />
          <div styleName="hamper__card">
          {/* <h2 styleName="hamper__title">Non-Subscribers</h2> */}
        

          <ul style={{ height: "70%" }}>
            <li>Dimmagi Naxal Shirt Black</li>
            <li>Dimmagi Naxal Shirt White</li>
            <li>Tote Bag</li>
            <li>Urban Naxal Mug</li>
            <li>Dimaagi Naxal Mug</li>
            <li>Naxal Bari Book</li>
            <li>3 x One Month Joint NL-TNM Subscription</li>
          </ul>
          <h2 styleName="hamper__price-1">
            <span styleName="rupee_sign1">Total </span>
            <span styleName="rupee_sign1">₹</span>
            <span
              styleName="rupee_sign1"
              style={{ textDecoration: "line-through" }}
            >
              5142
            </span>
          </h2>
          <h2 styleName="hamper__price-1">
            <span styleName="rupee_sign">₹</span>3860
          </h2>

          <button onClick={handleBuyNow("pl_TccAEmxI2ALVfY")}>Buy Now</button>
        </div></>}
      </div>

      {/* terms and conditions section */}
      <div>
        <strong>Terms &amp; Conditions</strong>
      </div>
      <ul styleName="notes_wrapper">
        <li styleName="notes_lines">
          • This is a limited period offer till September 30, 2026.
        </li>
        <li styleName="notes_lines">• Delivery in India only. </li>
        <li styleName="notes_lines">
          • If you already have a subscription, you can gift the subscription to
          your friend/family.
          <br />
          Just email us at{" "}
          <a
            style={{ color: "var(--text-accent-muted)" }}
            href="mailto:subscription@newslaundry.com"
          >
            subscription@newslaundry.com
          </a>
          .
        </li>
        <li styleName="notes_lines">
          • If you are based out of India, you can share an Indian address for
          the merch delivery.
        </li>
        <li styleName="notes_lines">
          • Please note, delivery of packages will take at least two to three
          weeks. Please be patient with us.
        </li>
        <li styleName="notes_lines">
          • Once you gift a subscription, it will be mapped within 48 hours.
        </li>
        <li styleName="notes_lines">
          • The product images shown may not be an exact representation of the
          product.
        </li>
        <li styleName="notes_lines">
          • If you have any queries, please drop an email on{" "}
          <a
            style={{ color: "var(--text-accent-muted)" }}
            href="mailto:store@newslaundry.com"
          >
            store@newslaundry.com
          </a>
          .
        </li>
      </ul>
      <br />
    </div>
  );
}
